import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'reportstatus',
    standalone: false
})
export class ReportStatusPipe implements PipeTransform {
  transform(value: number): any {
    switch (value) {
      case 100:
        return 'In progress';
      case 200:
        return 'Generated';
      default:
    }
  }
}
